export const apiBaseUrl = (): string => {
  return process.env.REACT_APP_API_URI || `/api`;
};
